import { Locale } from "@redotech/crdb-enums/common/locale";
import { TRANSLATION_SOURCES } from "@redotech/redo-customer-portal-common/translation-source";
import * as z from "zod";

/**
 * The team's saved translations for the given flow elements (multiple choice
 * steps and options, by their stable uuid), across all languages — the flow
 * editor's read for its per-language text panels.
 */
export const getFlowElementTranslations = {
  name: "getFlowElementTranslations" as const,
  input: z.object({ elementIds: z.array(z.string().max(100)).max(200) }),
  output: z.object({
    translations: z.array(
      z.object({
        elementId: z.string(),
        field: z.string(),
        language: z.enum(Locale),
        text: z.string(),
        source: z.enum(TRANSLATION_SOURCES),
        sourceText: z.string().nullable(),
      }),
    ),
  }),
};
